import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import img1 from "../../assets/images/PD.jpg";
import img2 from "../../assets/images/dv.svg";
import img3 from "../../assets/images/DFT.jpg";
import img4 from "../../assets/images/STA.svg";
import img5 from "../../assets/images/im.jpeg";
import img6 from "../../assets/images/analog.png";






const services = [
  {
    title: "Physical Design",
    img: img1,
    desc: "Crafting efficient and manufacturable chip layouts with precision.",
    points: [
      "RTL-to-GDSII implementation for industry-standard designs",
      "Floor planning, placement, and partitioning",
      "Clock Tree Synthesis (CTS) & timing closure",
    ],
  },
  {
    title: "Design for Test (DFT)",
    img: img2,
    desc: "Ensuring reliability and testability with modern DFT methodologies.",
    points: [
      "Scan-based ATPG for high fault coverage",
      "Scan compression & Memory BIST",
      "JTAG debugging and validation",
    ],
  },
  {
    title: "Design Verification",
    img: img3,
    desc: "Validating designs for accuracy, efficiency, and silicon success.",
    points: [
      "Functional verification using UVM/OVM",
      "Code & functional coverage",
      "Expertise in Verilog & VHDL",
    ],
  },
  {
    title: "Synthesis & Static Timing Analysis (STA)",
    img: img4,
    desc: "Delivering optimized designs with timing precision.",
    points: [
      "High-quality synthesis for area & power",
      "Multi-mode multi-corner timing optimization",
      "Critical path analysis",
    ],
    
  },
  {
    title: "EM/IR/PDN",
    img: img5,
    desc: "Ensuring robust power integrity and long-term reliability of VLSI designs.",
    points: [
      "IR drop and electromigration analysis",
      "Power Delivery Network (PDN) planning and optimization",
      "Reliability checks across voltage, current, and temperature corners",
    ],
  },
  {
    title: "Analog Layout",
    img: img6,
    desc: "Creating high-precision analog and mixed-signal layouts to ensure performance, matching, and reliability.",
    points: [
      "Device matching, symmetry, and common-centroid layouts",
      "Shielding, guard rings, and noise isolation techniques",
      "DRC, LVS, and EM-aware layout practices",
    ],
  }
  
  
];

const ServicesSection: React.FC = () => {
  return (
    <section className="services-section">
      <Container>
        <h2 className="services-title text-center mb-5">
          Our Creative Services
        </h2>

        <Row>
          {services.map((service:any, idx) => (
            <Col md={6} lg={4} key={idx} className="mb-4">
              <Card className="service-card h-100">
                <div className="service-img">
                  <Card.Img variant="top" src={service.img} />
                </div>
                <Card.Body>
                  <Card.Title className="service-card-title">
                    {service.title}
                  </Card.Title>
                  <Card.Text className="service-desc">
                    {service.desc}
                  </Card.Text>
                  <ul className="service-points">
                    {service.points.map((p:any, i:any) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;
